var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#007F9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.05 8.3h6.3a6.75 6.75 0 016.75 6.75v6.3a6.75 6.75 0 01-6.75 6.75h-6.3a6.75 6.75 0 01-6.75-6.75v-6.3a6.75 6.75 0 016.75-6.75zm0 2.25a4.5 4.5 0 00-4.5 4.5v6.3a4.5 4.5 0 004.5 4.5h6.3a4.5 4.5 0 004.5-4.5v-6.3a4.5 4.5 0 00-4.5-4.5zm8.325 2.025A1.125 1.125 0 1122.25 13.7a1.125 1.125 0 011.125-1.125zm-6.075.675a4.05 4.05 0 11-4.05 4.05 4.05 4.05 0 014.05-4.05zm0 2.25a1.8 1.8 0 101.8 1.8 1.8 1.8 0 00-1.8-1.8z",
    fill: "#FFF"
  })));
}

export default SvgInstagram;